import deepmerge from "@node/deepmerge"

let locales = {}
const modules = import.meta.glob("@o-din-stock/../../config/locales/**/*.yml", { eager: true });

for (const path in modules) {
  locales = deepmerge(locales, modules[path].default);
}

import store from "@o-din-stock/src/stock/store";
import menu from "@o-din-stock/src/stock/menu.json";

export default {
  routes: [
    { path: '/stock/items', component: () => import("./views/stock/items/Index.vue") },
    { path: '/stock/items/new', component: () => import("./views/stock/items/Form.vue") },
    { path: '/stock/items/:id/edit', component: () => import("./views/stock/items/Form.vue") },
    { path: '/stock/items/:id', component: () => import("./views/stock/items/Show.vue") },
    { path: '/stock/categories', component: () => import("./views/stock/category/Index.vue") },
    { path: '/stock/categories/:id/edit', component: () => import("./views/stock/category/Update.vue") },
    { path: '/stock/materials', component: () => import("./views/stock/materials/Index.vue") },
    { path: '/stock/materials/:id/edit', component: () => import("./views/stock/materials/Form.vue") },
    { path: '/stock/materials/new', component: () => import("./views/stock/materials/Form.vue") },
    { path: '/stock/materials/:id', component: () => import("./views/stock/materials/Show.vue") }
  ],
  locales,
  store,
  menu: [menu]
}
